function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
export default function useTooltip() {
  var _useState = useState({
    tooltipOpen: false,
    tooltipLeft: undefined,
    tooltipTop: undefined,
    tooltipData: undefined
  }),
      tooltipState = _useState[0],
      setTooltipState = _useState[1];

  var updateTooltip = function updateTooltip(_ref) {
    var tooltipOpen = _ref.tooltipOpen,
        tooltipLeft = _ref.tooltipLeft,
        tooltipTop = _ref.tooltipTop,
        tooltipData = _ref.tooltipData;
    return setTooltipState(function (prevState) {
      return _extends({}, prevState, {
        tooltipOpen: tooltipOpen,
        tooltipLeft: tooltipLeft,
        tooltipTop: tooltipTop,
        tooltipData: tooltipData
      });
    });
  };

  var showTooltip = function showTooltip(_ref2) {
    var tooltipLeft = _ref2.tooltipLeft,
        tooltipTop = _ref2.tooltipTop,
        tooltipData = _ref2.tooltipData;
    return updateTooltip({
      tooltipOpen: true,
      tooltipLeft: tooltipLeft,
      tooltipTop: tooltipTop,
      tooltipData: tooltipData
    });
  };

  var hideTooltip = function hideTooltip() {
    return updateTooltip({
      tooltipOpen: false,
      tooltipLeft: undefined,
      tooltipTop: undefined,
      tooltipData: undefined
    });
  };

  return {
    tooltipOpen: tooltipState.tooltipOpen,
    tooltipLeft: tooltipState.tooltipLeft,
    tooltipTop: tooltipState.tooltipTop,
    tooltipData: tooltipState.tooltipData,
    updateTooltip: updateTooltip,
    showTooltip: showTooltip,
    hideTooltip: hideTooltip
  };
}